import { Alert } from "ra-friendsofbabba";
import React from "react";
import { useFormState } from "react-final-form";
import { useTranslate } from "ra-core";

const AttachmentsWarnField = () => {
  const translate = useTranslate();
  const form = useFormState();
  return (
    <Alert severity="warning">
      <div>{translate("resources.projects.fields.media.warn")}</div>
      {form.dirty && <br />}
      {form.dirty && (
        <div
          style={{ fontWeight: "bold" }}
          dangerouslySetInnerHTML={{
            __html: translate(`resources.projects.fields.docs.warn`),
          }}
        />
      )}
    </Alert>
  );
};
export default AttachmentsWarnField;
